export default __webpack_public_path__ + "static/media/eduPink.7e1f22af.svg";